export default "__VITE_ASSET__D1BSLr4o__"